export function importantEventsReducer(PRELOAD) {
    const important_events_initial = {
        unread: PRELOAD.important_events.reduce((accum, event) => (event.unread ? ++accum : accum), 0),
        events: PRELOAD.important_events,
    };
    return (state = important_events_initial, action) => {
        switch (action.type) {
            case 'APPLY_NEW_EVENT':
                if (action.event.important) {
                    return {
                        unread: state.unread + 1,
                        events: [action.event, ...state.events],
                    };
                }
                else {
                    return state;
                }
            case 'MARK_ALL_EVENTS_AS_READ':
                return {
                    unread: 0,
                    events: state.events,
                };
            case 'IMPORTANT_EVENTS_RELOADED':
                return {
                    unread: action.events.reduce((accum, event) => (event.unread ? ++accum : accum), 0),
                    events: action.events,
                };
            default:
                return state;
        }
    };
}
